import authActions from 'store/modules/auth'

export const USER_MENU = [{
  title: 'Pools',
  link: 'pools',
}, {
  title: 'Access Token',
  link: 'access_token',
}, {
  title: 'Secrets',
  link: 'secrets',
}, '-', {
  title: 'Docs',
  link: 'trynow',
}, {
  title: 'Pricing',
  link: 'pricing',
}, {
  title: 'Payment',
  link: 'payment',
}, {
  title: 'Contact',
  link: 'contact',
}, {
  title: 'Logout',
  handler: (dispatch, getState) => {
    dispatch(authActions.logout())
  },
}]

export const GUEST_MENU = [{
  title: 'Home',
  link: 'home',
}, {
  title: 'Try Now',
  link: 'trynow',
}, {
  title: 'Pricing',
  link: 'pricing',
}, {
  title: 'Contact',
  link: 'contact',
}, {
  title: 'Register / Login',
  link: 'login',
}]
